(() => {
  const setupGalleryArrows = (gallery) => {
    if (gallery.dataset.tarantellaArrowsInit === 'true') return;
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    const nav = viewer?.querySelector('.product__media-list + .slider-buttons');
    const prev = nav?.querySelector('.slider-button--prev');
    const next = nav?.querySelector('.slider-button--next');
    if (!viewer || !nav || !prev || !next) return;
    gallery.dataset.tarantellaArrowsInit = 'true';

    const getItems = () => Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]'));
    const getActiveIndex = () => {
      const items = getItems();
      const index = items.findIndex((item) => item.classList.contains('is-active'));
      return index >= 0 ? index : 0;
    };

    const updateButtons = () => {
      const items = getItems();
      const index = getActiveIndex();
      prev.disabled = index <= 0;
      next.disabled = index >= items.length - 1;
    };

    const goTo = (direction) => {
      const items = getItems();
      const index = getActiveIndex();
      const targetIndex = direction === 'next' ? index + 1 : index - 1;
      if (targetIndex < 0 || targetIndex >= items.length) return;
      const targetId = items[targetIndex].dataset.mediaId;
      if (!targetId || typeof gallery.setActiveMedia !== 'function') return;
      gallery.setActiveMedia(targetId, false);
      updateButtons();
    };

    prev.addEventListener('click', (event) => {
      event.preventDefault();
      goTo('prev');
    });

    next.addEventListener('click', (event) => {
      event.preventDefault();
      goTo('next');
    });

    viewer.addEventListener('slideChanged', updateButtons);
    new MutationObserver(updateButtons).observe(viewer, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    updateButtons();
  };

  const init = () => {
    document.querySelectorAll('media-gallery[data-desktop-layout="thumbnail_slider"]').forEach(setupGalleryArrows);
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
